import {
  getFromLocalStorage,
  setLocalStorageWithExpiry,
} from "../../utils/local-storage"

let locationInfo: object | null = null
let req: Promise<Response | void> | null = null
let rejectQueue: Array<any> = []
let resolveQueue: Array<any> = []

export type LocationInfo = {
  country_code: string
  country_name: string
  continent: string
  region: string
  world_region: string
}

/**
 * Fetch location details from our /__locate endpoint
 *
 * Restricts to a single AJAX call per page load, will resolve with the location info
 * whenever it’s returned
 *
 * Location info is an object of the format:
 *   {"country_code":"AU","country_name":"Australia","continent":"Australia","region":"Oceania","world_region":"APAC"}
 *
 * @return {Promise}
 */

export function fetchLocationInfo() {
  return new Promise((resolve, reject) => {
    if (locationInfo) {
      resolve(locationInfo)
    } else {
      rejectQueue.push(reject)
      resolveQueue.push(resolve)

      // Resolve with the location from localStorage if it exists there.
      locationInfo = getFromLocalStorage("locationInfo")

      if (locationInfo) {
        resolveQueue.forEach(cb => cb(locationInfo))
        return
      }

      if (!req) {
        const timestamp = Date.now().toString()
        req = fetch(`/__locate?t=${timestamp}`)
          .then(response => {
            if (!response.ok) {
              rejectQueue.forEach(cb => cb())
              return undefined
            } else {
              return response.json()
            }
          })
          .then(data => {
            locationInfo = data
            resolveQueue.forEach(cb => cb(locationInfo))
            // Store location in local storage for 3 hours.
            setLocalStorageWithExpiry("locationInfo", locationInfo, 10800)
          })
      }
    }
  })
}
